import CalendarDashboard from './CalendarDashboard';

export default CalendarDashboard;